import { io } from 'socket.io-client';
const SOCKET_URL = 'https://codetgt.onrender.com';
let socket = null;
export const connectSocket = () => {
    if(!socket){
        socket = io(SOCKET_URL, {
            transports: ['websocket'],
            autoConnect: true
        });
        socket.on('connect', () => {
      console.log('Connected to server:', socket.id);
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from server');
    });
  }
  return socket;
};

export const getSocket = () => {
  if (!socket) {
    return connectSocket();
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const joinRoom = (roomId) => {
  if (socket) {
    socket.emit('join-room', roomId);
  }
};

export const sendCodeChange = (roomId, code, cursorPosition) => {
  if (socket) {
    socket.emit('code-change', { roomId, code, cursorPosition });
  }
};

export const sendCursorMove = (roomId, cursorPosition) => {
  if (socket) {
    socket.emit('cursor-move', { roomId, cursorPosition });
  }
};